import { ComponentPropsWithoutRef } from 'react'

export function LogoTumblr20(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" {...props}>
      <path d="M15.083 15.965a4.4 4.4 0 0 1-1.543.345 1.728 1.728 0 0 1-1.842-1.97V8.115h3.844V5.087h-3.835V0H8.904a.154.154 0 0 0-.138.15A6.12 6.12 0 0 1 5 5.533v2.582h1.937v6.533c-.034 2.921 2.329 5.318 5.278 5.351q.235.003.472-.014c1.407-.025 2.968-.636 3.313-1.171l-.917-2.851" />
    </svg>
  )
}
